import { ReactElement } from 'react'
import styled from 'styled-components'

import { TRGBColor } from 'types/maps'
import { FormattedMessage } from 'react-intl'
import { CloseIcon } from 'components/Icons'

// Create color options array
const colorOptions: TRGBColor[] = [
  [57, 57, 57],
  [0, 200, 117],
  [93, 89, 215],
  [145, 110, 232],
  [209, 27, 223],
  [245, 58, 88],
  [255, 168, 0],
  [255, 208, 2]
]

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Title = styled.span`
  font-weight: bold;
  font-size: 14px;
`

const CloseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;

  svg {
    width: 18px;
    height: 18px;
  }
`

const ColorGrid = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

const ColorSwatch = styled.div<{ bgColor: TRGBColor }>`
  width: 18px;
  height: 18px;
  background-color: ${({ bgColor }): string => `rgb(${bgColor[0]}, ${bgColor[1]}, ${bgColor[2]})`};
  cursor: pointer;
  border-radius: 50%;
`

interface IColorPickerProps {
  onClose: () => void
  pickColor: (color: TRGBColor) => void
}

export const ColorPicker = ({ onClose, pickColor }: IColorPickerProps): ReactElement => {
  return (
    <Container>
      <Header>
        <Title>
          <FormattedMessage id="routingProjects.colorPicker.title" defaultMessage="Color" />
        </Title>
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </Header>
      <ColorGrid>
        {colorOptions.map((color, index) => (
          <ColorSwatch
            key={index}
            bgColor={color}
            onClick={(): void => {
              pickColor(color)
              onClose()
            }}
          />
        ))}
      </ColorGrid>
    </Container>
  )
}
